import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";
import { getProjectData } from "../../../../store/Api";
import { axios } from "../../../../Global";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { sortByName } from "../../../../utils/sortByName";

export default function Addlocaltransfer({ setTrigger, trigger }) {
  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    sponsor_id: Yup.string(),
    nationality_id: Yup.string(),
    project_id: Yup.number(),
    selection_date: Yup.string(),
    religion: Yup.string(),
    name: Yup.string(),
    job_position_id: Yup.number(),
    visa_profession_id: Yup.number(),
    passport_number: Yup.string(),
    dob: Yup.string(),
    basic: Yup.string(),
    food: Yup.string(),
    fixed_ot: Yup.string(),
    hra: Yup.string(),
    travel_allowance: Yup.string(),
    mobile_allowance: Yup.string(),
    air_ticket_allowance: Yup.string(),
    additional_ot: Yup.string(),
    other_allowance: Yup.string(),
    duty_hours: Yup.number(),
    fixed_ot_hours: Yup.number(),
    passport_issue_date: Yup.string(),
    passport_expiry_date: Yup.string(),
    covid_vaccine: Yup.string(),
    blood_group: Yup.string(),
    arrival_date: Yup.string(),
    duration_of_contract: Yup.string(),
    sector_id: Yup.string(),
    emergency_contact_person_in_home_country: Yup.string(),
    emergency_contact_number_in_home_country: Yup.number(),
  });

  // const dob = new Date(row[9]);
  // const today = new Date();
  // const age = today.getFullYear() - dob.getFullYear();

  const {
    register,
    control,
    watch,
    handleSubmit,
    getValues,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const Project = useSelector((state) => state.projectData);
  const laravelToken = localStorage.getItem("token");
  const [visaProvider, setVisaProvider] = useState();

  console.log("project.....p,,,,,", Project);
  const visa_provider = async () => {
    const response = await axios.get("dashboard/company", {
      headers: {
        Authorization: `Bearer ${laravelToken}`,
      },
    });
    if (response.status === 200) {
      console.log(
        "res?.data?.data?.visa_profession",
        response?.data?.data?.company
      );
      setVisaProvider(sortByName(response?.data?.data?.company));
    }
  };
  const [professions, setProfessions] = useState();
  const profession = async () => {
    try {
      const response = await nodeinstance.get(
        "/dashboard/localTransfer/getProfessions",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setProfessions({
          ...response?.data?.data,
          Nationality: sortByName(response?.data?.data?.Nationality),
          Actualprofessions: sortByName(response?.data?.data?.Actualprofessions),
          visaProfessions: sortByName(response?.data?.data?.visaProfessions),
        });
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };
  const [sectorList, setSectorList] = useState();

  const Sectortoken = localStorage.getItem("token");
  const getSectors = () => {
    // setLoading({ listData: true });
    axios
      .get("/dashboard/sector", {
        headers: { Authorization: `Bearer ${Sectortoken}` },
      })
      .then((res) => {
        setSectorList(sortByName(res.data.data));
        // setLoading({ listData: false });
      })
      .catch((err) => {
        dispatch(setAppError({ msg: err.message }));
        // setLoading({ listData: false });
      });
  };

  useEffect(() => {
    dispatch(
      setBreadCrumb([
        {
          label: "OPS 1 MASTER DATABASE",
          link: "/dashboard/ops-1-master-database",
        },
        {
          label: "CREATE",
          // link: `/dashboard/project/${projectDetails?.id}`,
        },
      ])
    );
    dispatch(getProjectData(laravelToken));
    visa_provider();
    profession();
    getSectors();
  }, []);
  const [dropDownData, setDropDownData] = useState();
  const dropData = [
    {
      id: 1,
      name: "YTC",
    },
  ];
  const token = localStorage.getItem("nodeToken");
  const [responseData, setResponseData] = useState();
  const handleProjectChange = async (event) => {
    const response = await nodeinstance.get(
      `/dashboard/localTransfer/getfieldsDatabyProjectId/${event.target.value}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      setResponseData(response?.data?.data);
    }
  };
  console.log("responseData", responseData);
  const [visaData, setVisaData] = useState();
  const handleVisaChange = (event) => {
    console.log(
      "event visa....................",
      JSON.parse(event.target.value)
    );
    setVisaData(JSON.parse(event.target.value));
  };
  console.log("professions.....professions", professions);

  const BloodGroups = [
    {
      name: "A+",
    },
    {
      name: "A-",
    },
    {
      name: "B+",
    },
    {
      name: "B-",
    },
    {
      name: "AB+",
    },
    {
      name: "AB-",
    },
    {
      name: "O+",
    },
    {
      name: "O-",
    },
  ];
  const formRef = useRef(null);

  const formChange = (event) => {
    let formDetails = getValues();
  };
  const navigate = useNavigate();
  const onSubmit = async (data) => {
    try {
      let reqObject = {
        ...data,
        age: age,
        point_of_hire: "LOCAL",
        status: "ARRIVED",
        company_id: visaData.id,
        sponsor_id: visaData.sponsor_id,
      };
      const dataCheck = reqObject.duration_of_contract.split("");

      if (isNaN(parseInt(dataCheck[0]))) {
        // throw new Error("The first character of duration_of_contract is not an integer");
        dispatch(
          setAppError({
            msg: "The first character of duration of employee contract should be integer",
          })
        );
        return;
      }
      console.log("success............");

      const response = await nodeinstance.post(
        "/dashboard/localTransfer/create",
        reqObject,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        dispatch(
          setAppError({
            msg: "Candidate created successfully..",
            color: "success",
          })
        );
        setTrigger(!trigger);
        navigate("/dashboard/ops-1-master-database");
      }
    } catch (error) {
      console.log("errpr......", error);
      dispatch(
        setAppError({
          msg: "Unable to create candidate",
        })
      );
    }
  };

  const onCancelClick = () => {
    navigate("/dashboard/ops-1-master-database");
  };
  const Religion = [
    {
      name: "MUSLIM",
    },
    {
      name: "NON MUSLIM",
    },
  ];

  const [age, setAge] = useState();
  const handleAgechange = (event) => {
    setAge(
      new Date().getFullYear() - new Date(event.target.value).getFullYear()
    );
    //  date =  new Date().getFullYear() - event.target.value.getFullYear();
    console.log(
      "jdgcgygdyucutduy....d.d..d.d.",
      new Date().getFullYear() - new Date(event.target.value).getFullYear()
    );
  };
  return (
    <>
      <form
        onChange={formChange}
        ref={formRef}
        onSubmit={handleSubmit(onSubmit)}
        autoComplete="off"
      >
        <div className="flex flex-col justify-center items-center bg-white dark:bg-dark rounded-md py-5">
          <h2 className="text-xl font-semibold">CREATE</h2>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              VISA COST/ TRANSFER COST
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              PROJECT NAME
            </label>
            {/* <select
              {...register("project_id")}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              // value={visaData?.name}
              onChange={handleProjectChange}
            >
              {Project?.data?.map((data, index) => (
                <React.Fragment key={index}>
                  {index === 0 ? (
                    <option>{"select value"}</option>
                  ) : (
                    <option value={data.id}>{data.name}</option>
                  )}
                </React.Fragment>
              ))}
            </select> */}
            <select
              {...register("project_id")}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              onChange={handleProjectChange}
            >
              <option value="">Select value</option>
              {Project?.data?.map((data) => (
                <option key={data.id} value={data.id}>
                  {data.name}
                </option>
              ))}
            </select>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              QUOTATION TYPE
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              value={
                responseData && responseData[0]?.quotation_type
                  ? responseData[0]?.quotation_type
                  : null
              }
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              QUOTATION NUMBER
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              value={
                responseData && responseData[0]?.quotation_number
                  ? responseData[0]?.quotation_number
                  : null
              }
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              CONTRACT NUMBER
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              value={responseData && responseData[0]?.contract_number}
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              CLIENT NAME
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              value={responseData && responseData[0]?.client_name}
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              VISA PROVIDER
            </label>
            <select
              // {...register("visaprovider")}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              // value={visaData?.name}
              onChange={handleVisaChange}
            >
              <option>{"select value"}</option>
              {visaProvider?.map((data, index) => (
                <React.Fragment key={index}>
                  <option value={JSON.stringify(data)}>{data.name}</option>
                </React.Fragment>
              ))}
            </select>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              NATIONALITY
            </label>
            <select
              {...register("nationality_id")}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              // value={visaData?.name}
              // onChange={handleVisaChange}
            >
              <option>{"select value"}</option>
              {professions?.Nationality?.map((data, index) => (
                <React.Fragment key={index}>
                  <option value={data.id}>{data.name}</option>
                </React.Fragment>
              ))}
            </select>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              RELIGION
            </label>
            <select
              {...register("religion")}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            >
              <option>{"select value"}</option>
              {Religion.map((data, index) => (
                <React.Fragment key={index}>
                  <option value={data.name}>{data.name}</option>
                </React.Fragment>
              ))}
            </select>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              NAME
            </label>
            <input
              {...register("name")}
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              PASSPORT NO
            </label>
            <input
              {...register("passport_number")}
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              ACTUAL PROFESSION
            </label>
            <select
              {...register("job_position_id")}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              // value={visaData?.name}
              // onChange={handleVisaChange}
            >
              <option>{"select value"}</option>
              {professions?.Actualprofessions?.map((data, index) => (
                <React.Fragment key={index}>
                  <option value={data.id}>{data.name}</option>
                </React.Fragment>
              ))}
            </select>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              DATE OF BIRTH
            </label>
            <input
              {...register("dob")}
              type="date"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              onChange={handleAgechange}
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              AGE
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              value={age ? age : ""}
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              BASIC SALARY
            </label>
            <input
              {...register("basic")}
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              FOOD ALLOWANCE
            </label>
            <input
              {...register("food")}
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              FIXED OT
            </label>
            <input
              {...register("fixed_ot")}
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              HRA
            </label>
            <input
              {...register("hra")}
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              TRAVEL ALLOWANCE
            </label>
            <input
              {...register("travel_allowance")}
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              MOBILE ALLOWANCE
            </label>
            <input
              {...register("mobile_allowance")}
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              AIR TICKET ALLOWANCE
            </label>
            <input
              {...register("air_ticket_allowance")}
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              ADDITIONAL OT
            </label>
            <input
              {...register("additional_ot")}
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              OTHER ALLOWANCE
            </label>
            <input
              {...register("other_allowance")}
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              DUTY HOURS
            </label>
            <input
              {...register("duty_hours")}
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              FIXED OT HOURS
            </label>
            <input
              {...register("fixed_ot_hours")}
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              DURATION OF EMPLOYEE CONTRACT
            </label>
            <input
              {...register("duration_of_contract")}
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              // value={responseData && responseData[0]?.tenure}
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              PROBATION PERIOD
            </label>
            <input
              {...register("probation_period")}
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              PASSPORT ISSUE DATE
            </label>
            <input
              {...register("passport_issue_date")}
              type="date"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              PASSPORT EXPIRY DATE
            </label>
            <input
              {...register("passport_expiry_date")}
              type="date"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              EMERGENCY CONTACT PERSON IN HOME COUNTRY
            </label>
            <input
              {...register("emergency_contact_person_in_home_country")}
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              EMERGENCY CONTACT NUMBER IN HOME COUNTRY
            </label>
            <input
              {...register("emergency_contact_number_in_home_country")}
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              COVID VACCINE
            </label>
            <input
              {...register("covid_vaccine")}
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              BLOOD GROUP
            </label>
            <select
              {...register("blood_group")}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            >
              <option>{"select value"}</option>
              {BloodGroups?.map((data, index) => (
                <React.Fragment key={index}>
                  <option value={data.name}>{data.name}</option>
                </React.Fragment>
              ))}
            </select>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              SPONSOR ID
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              value={visaData?.sponsor_id}
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              VISA PROFESSION
            </label>
            <select
              {...register("visa_profession_id")}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              // value={visaData?.name}
              // onChange={handleVisaChange}
            >
              <option>{"select value"}</option>
              {professions?.visaProfessions?.map((data, index) => (
                <React.Fragment key={index}>
                  <option value={data.id}>{data.name}</option>
                </React.Fragment>
              ))}
            </select>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              DATE OF ARRIVAL
            </label>
            <input
              {...register("arrival_date")}
              type="date"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              PROJECT INCHARGE
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              value={responseData && responseData[0]?.project_coordinator}
              disabled
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              CANDIDATE STATUS
            </label>
            <input
              type="text"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              value={"ARRIVED"}
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit - name`} className="text-xs ">
              ARRIVAL SECTOR
            </label>
            <select
              {...register("sector_id")}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              // value={visaData?.name}
              // onChange={handleVisaChange}
            >
              <option>{"select value"}</option>
              {sectorList?.map((data, index) => (
                <React.Fragment key={index}>
                  <option value={data.id}>{data.name}</option>
                </React.Fragment>
              ))}
            </select>
          </div>

          <div className="p-2  w-full max-w-md flex gap-3">
            {/* <button
              className="w-full ring-1 rounded-md text-xs ring-black"
              onClick={() => onCancelClick()}
            >
              Cancel
            </button> */}

            <button
              className="bg-red dark:bg-red w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
              type="submit"
              //   disabled={submitFormLoading}
            >
              <p>Submit</p>
              {/* {submitFormLoading ? (
                <CgSpinner className="animate-spin" />
              ) : (
                <HiArrowLongRight size={"1.2rem"} />
              )} */}
            </button>
          </div>
        </div>
      </form>
    </>
  );
}
